import { useParams } from 'react-router-dom';
import { BulletinBoardsCreateContent } from './bulletin-boards-create-content';
import { BulletinBoardsCreateSidedar } from './bulletin-boards-create-sidebar';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { t } from 'i18next';
import { useClient } from 'jsonapi-react';
import { Dashboard, DashboardContent } from '@/layouts/dashboard';

export function BulletinBoardsCreate() {
  const { id } = useParams();
  const client = useClient();
  const [isEditing, setIsEditing] = useState(false);
  const [bannerDetails, setBannerDetails] = useState(null);

  const getBannerDetails = async () => {
    try {
      const { data, error } = await client.fetch(`/bulletin_boards/${id}`);
      if (error) {
        toast.error(t('bulletinBoards.errorFetchingBannerDetails'));
      } else {
        setBannerDetails(data);
      }
    } catch (error) {
      toast.error(t('bulletinBoards.errorFetchingBannerDetails'));
      console.error(error);
    }
  };

  useEffect(() => {
    if (id) {
      getBannerDetails();
      setIsEditing(true);
    }
  }, [id]);

  return (
    <Dashboard>
      <BulletinBoardsCreateSidedar />
      <DashboardContent viewMode="create">
        <BulletinBoardsCreateContent
          isEditing={isEditing}
          bannerData={bannerDetails}
        />
      </DashboardContent>
    </Dashboard>
  );
}
